const inactiveProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.statuses?.inactive,
    0,
  )
}

export default inactiveProcess
